import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import type { FC, ReactElement, ReactNode } from 'react';

import { palette } from '../../theme/palette';

type BannerProps = {
  backgroundColor: string;
  textColor?: string;
  borderColor?: string;
  icon: ReactElement;
  title?: string;
  children: ReactNode;
  onDismiss?: () => void;
};

export const Banner: FC<BannerProps> = ({
  backgroundColor,
  borderColor = 'transparent',
  textColor = palette.SlabGray[700],
  icon,
  title,
  children,
  onDismiss,
}) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      borderRadius: '8px',
      border: `1px solid ${borderColor}`,
      backgroundColor,
      p: 2,
    }}
  >
    <Box>{icon}</Box>
    <Stack sx={{ flex: 1, gap: 1 }}>
      {title ? (
        <Typography
          variant='h6'
          color={textColor}
          sx={{ fontWeight: '500', fontSize: '18px', lineHeight: '24px' }}
        >
          {title}
        </Typography>
      ) : undefined}
      <Typography
        variant='body3'
        color={textColor}
        sx={{ fontWeight: '400', fontSize: '16px', lineHeight: '24px' }}
      >
        {children}
      </Typography>
    </Stack>
    {onDismiss ? (
      <IconButton size='small' onClick={onDismiss} aria-label='Dismiss'>
        <CloseIcon sx={{ width: '18px', height: '18px', color: textColor }} />
      </IconButton>
    ) : undefined}
  </Box>
);
